<template>
    <div>
        <Modal v-model="isShowModal" :title="title" @on-cancel="hide('formValidate')" :mask-closable="false" width="80%">
            <Card :bordered="false" :style="{ marginBottom: '10px' }">
                <div class="hs-screen-row">
                    <Select v-model="params.orderState" placeholder="订单状态" clearable style="width:200px">
                        <Option value="">全部</Option>
                        <Option value="1">未接单</Option>
                        <Option value="2">已接单</Option>
                        <Option value="3">已完成</Option>
                        <Option value="4">已取消</Option>
                    </Select>
                </div>
<!--                <div class="hs-screen-row">-->
<!--                    <Select v-model="params.recoveryUserId" placeholder="回收员" clearable style="width:200px">-->
<!--                        <Option v-for="(item, index) in recoveryUserList" :value="item.value" :key="index">{{ item.label }}</Option>-->
<!--                    </Select>-->
<!--                </div>-->
                <div class="hs-screen-row">
                    <DatePicker @on-change="changeDate" v-model="dateInit" type="daterange" :editable="false"
                        separator=" ~ " split-panels transfer placeholder="创建时间" style="width: 200px"></DatePicker>
                </div>
                <div class="hs-screen-row">
                    <DatePicker @on-change="changeSuccessDate" v-model="successDateInit" type="daterange" :editable="false"
                        separator=" ~ " split-panels transfer placeholder="完成时间" style="width: 200px"></DatePicker>
                </div>
                <div class="hs-screen-row">
                    <Button type="primary" @click="findList">查询</Button>
                </div>
                <div class="hs-screen-row">
                    <Button @click="resetScreen">重置</Button>
                </div>
            </Card>

            <Card :bordered="false" :style="{ marginBottom: '10px' }">
                <!--表格数据-->
                <Table :columns="columns" :data="data" size="small" :stripe="true" >
                    <template slot-scope="{ row, index }" slot="orderState">
                      <span v-if="row.orderState == 1"><Tag color="success">等待确认</Tag></span>
                      <span v-if="row.orderState == 2"><Tag color="warning">等待回收</Tag></span>
                      <span v-if="row.orderState == 3"><Tag color="default">运输中</Tag></span>
                      <span v-if="row.orderState == 4"><Tag color="default">待验收</Tag></span>
                      <span v-if="row.orderState == 5"><Tag color="default">已完成</Tag></span>
                      <span v-if="row.orderState == 6"><Tag color="default">已取消</Tag></span>
                    </template>

                    <template slot-scope="{ row, index }" slot="orderType">
                        <span v-if="row.orderType == 1">
                            <Tag color="success">线上订单</Tag>
                        </span>
                        <span v-if="row.orderType == 2">
                            <Tag color="warning">线下订单</Tag>
                        </span>
                    </template>

                    <template slot-scope="{ row, index }" slot="payType">
                        <span v-if="row.payType == 1">
                            <Tag color="success">线上支付</Tag>
                        </span>
                        <span v-if="row.payType == 2">
                            <Tag color="warning">线下支付</Tag>
                        </span>
                        <span v-if="row.payType == 3">
                            <Tag color="primary">积分支付</Tag>
                        </span>
                    </template>

                    <template slot-scope="{ row, index }" slot="isAbnormal">
                        <span v-if="row.isAbnormal == 0">
                            <Tag color="success">正常</Tag>
                        </span>
                        <span v-if="row.isAbnormal == 1">
                            <Tag color="error">异常</Tag>
                        </span>
                    </template>

                    <template slot-scope="{ row, index }" slot="recoveryTime">

                        <span v-if="row.recoveryTime">
                            <span v-if="row.recoveryTimeStatus && row.recoveryTimeStatus === 0">
                                {{ row.recoveryTime }}
                            </span>
                            <span style="color: #FF8C00" v-else-if="row.recoveryTimeStatus && row.recoveryTimeStatus === 1">
                                {{ row.recoveryTime }}
                            </span>
                            <span style="color: red" v-else-if="row.recoveryTimeStatus && row.recoveryTimeStatus === 2">
                                {{ row.recoveryTime }}
                            </span>
                            <span v-else>
                                {{ row.recoveryTime }}
                            </span>
                        </span>
                        <span v-else>-</span>
                    </template>

                    <template slot-scope="{ row, index }" slot="totalAmount">
                        <span v-if="row.totalAmount">{{ row.totalAmount }}</span>
                        <span v-else>-</span>
                    </template>

                    <template slot-scope="{ row, index }" slot="realName">
                        <span v-if="row.realName">{{ row.realName }}</span>
                        <span v-else>{{ row.nickName }}</span>
                        <span v-if="row.isVip == 1">
                            <Tag color="warning"> VIP </Tag>
                        </span>
                    </template>

                    <template slot-scope="{ row, index }" slot="integral">
                        <span v-if="row.integral">{{ row.integral }}</span>
                        <span v-else>-</span>
                    </template>

                    <template slot-scope="{ row, index }" slot="updateTime">
                        <span v-if="row.orderState === 3">{{ row.updateTime }}</span>
                        <span v-else>-</span>
                    </template>

                </Table>
                <!--分页-->
                <div class="hs-page">
                    <Page :total="total" show-sizer show-total transfer @on-change="changePage"
                        @on-page-size-change="changePageSize" />
                </div>
            </Card>

            <!-- 重写对话框底部按钮 -->
            <div slot="footer">
                <Button @click="hide('formValidate')">取消</Button>
            </div>
        </Modal>
    </div>
</template>
  
<script>
export default {
    data() {
        return {
            dateInit: '',
            successDateInit: '',
            isShowModal: false,
            loadingBtn: false,
            title: '历史订单',
            total: 0,
            params: {
                page: 1,
                rows: 10,
                orderTitle: '',
                orderState: '',
                orderType: '',
                nickName: '',
                startTime: '',
                endTime: '',
                recoveryUserId: '',
                payType: '',
                startUpdateTime: '',
                endUpdateTime: '',
                tenantId: '',
                userId: ''
            },
            isTableLoading: false,
            // 表格列
          columns: [
            /*{
                type: 'selection',
                width: 60,
                align: 'center'
            },*/
            {
              type: 'index',
              width: 60,
              align: 'center'
            },
            {
              title: 'ID',
              minWidth: 130,
              key: 'recoveryOrderId'
            },
            {
              title: '订单编号',
              minWidth: 190,
              key: 'orderCode'
            },
            {
              title: '订单标题',
              minWidth: 90,
              key: 'orderTitle',
              ellipsis: true
            },
            {
              title: '订单状态',
              slot: 'orderState',
              align: 'center',
              width: 120
            },
            {
              title: '快递类型',
              slot: 'expressType',
              align: 'center',
              width: 120
            },
            {
              title: '快递面单号',
              minWidth: 160,
              key: 'mailNo',
              ellipsis: true
            },
            {
              title: '预约时间',
              slot: 'recoveryTime',
              align: 'center',
              width: 170
            },
            {
              title: '预估重量',
              minWidth: 190,
              key: 'estimateWeight'
            },
            {
              title: '质检结果',
              slot: 'isPass',
              align: 'center',
              width: 120
            },
            {
              title: '回收金额（元）',
              minWidth: 120,
              slot: 'totalAmount'
            },
            {
              title: '赠送积分',
              minWidth: 120,
              slot: 'integral'
            },
            {
              title: '用户名',
              minWidth: 180,
              slot: 'realName'
            },
            {
              title: '创建时间',
              key: 'createTime',
              width: 150
            },
            {
              title: '完成时间',
              slot: 'updateTime',
              width: 150
            },
            {
              title: '操作',
              slot: 'action',
              width: 225,
              align: 'center',
              fixed:'right'
            }
          ],
            // 表格数据
            data: [],
            recoveryUserList: [], // 回收员
        }
    },
    methods: {
        // 显示模态框
        show(row) {
            this.isShowModal = true;
            this.params.userId = row.userId
            this.findList(row);
            this.findRecoveryUserList()
        },
        // 查询用户订单
        findList(row) {
            this.$Spin.show();
            this.axios.post('/recoveryOrder/findList', this.params).then(res => {
                setTimeout(() => {
                    this.$Spin.hide();
                }, 300);
                this.isTableLoading = false;
                if (res.status == 200) {
                    this.total = res.data.total;
                    this.data = res.data.rows;
                }
                if (res.status == 500) {
                    this.$Notice.error({
                        title: '服务器内部错误',
                        desc: '查询订单列表接口报错',
                        duration: 0
                    });
                }
            })
        },
        inited(viewer) {
            this.$viewer = viewer
        },
        // 关闭模态框
        hide(name) {
            this.isShowModal = false;
        },
        // 改变页数
        changePage(e) {
            this.params.page = e;
            this.findList();
        },
        // 改变页容量
        changePageSize(e) {
            this.params.rows = e;
            this.findList();
        },
        // 回收员-列表查询
        findRecoveryUserList() {
            let params = {
                page: 1,
                rows: 20,
                isDisable: 0,
                tenantId: this.params.tenantId
            }
            this.axios.post('/recoveryUser/findList', params).then(res => {
                if (res.status == 200) {
                    if (res.data.rows) {
                        this.recoveryUserList = []
                        res.data.rows.forEach(v => {
                            let object = {
                                value: v.recoveryUserId,
                                label: v.realName
                            }
                            this.recoveryUserList.push(object)
                        })
                    }
                }
                if (res.status == 500) {
                    this.$Notice.error({
                        title: '服务器内部错误',
                        desc: '查询回收员列表接口报错',
                        duration: 0
                    });
                }
            })
        },
        // 日期条件赋值
        changeDate(e) {
            this.params.startTime = e[0];
            this.params.endTime = e[1];
        },
        changeSuccessDate(e) {
            this.params.startUpdateTime = e[0];
            this.params.endUpdateTime = e[1];
        },
        // 重置筛选条件
        resetScreen() {
            this.params.orderState = '';
            this.params.orderType = '';
            this.params.nickName = '';
            this.params.username = '';
            this.params.startTime = '';
            this.params.endTime = '';
            this.params.recoveryUserId = '';
            this.params.startUpdateTime = '';
            this.params.endUpdateTime = '';
            this.dateInit = '';
            this.successDateInit = '';
        },
    },
}
</script>
  
<style scoped>.jw-images-row {
    display: flex;
    align-items: center;
}

.jw-image {
    width: 150px;
    height: 150px;
    margin-right: 10px;
}</style>
  